import {Pipe, PipeTransform} from '@angular/core';
import {columnTypes, UITableHeader} from '../shared/ui-kits/table/table.models';
import {AbstractControl} from '@angular/forms';

@Pipe({
  name: 'sortTable',
  pure: true,
})
export class SortTablePipe implements PipeTransform {
  private dateRegex = /\/\d\d\//;
  transform(data: any, clickedHeader: UITableHeader, type: string): any {
    const column = clickedHeader?.key;
    const sortedData = data.sort((a: any, b: any) => {
      if (Array.isArray(a[column])) return;
      if ('controls' in a) return this.sortFormArray(a, b, column, type);
      if (!a[column] && !b[column]) return;
      // Check for nested object like dropdown
      // If it's not null change the current element to name key
      if (clickedHeader?.type === columnTypes.dropDown) {
        a[column] = a[column]?.name ? a[column].name : a[column];
        b[column] = b[column]?.name ? b[column].name : b[column];
      }
      if (typeof a[column] === 'number' && typeof b[column] === 'number')
        return this.sortNumber(a[column], b[column], type);

      if (
        a[column]?.match(this.dateRegex) &&
        b[column]?.match(this.dateRegex)
      ) {
        const first = +a[column].split('/').reverse().join('');
        const second = +b[column].split('/').reverse().join('');
        if (type === 'INC') {
          return first - second;
        }
        if (type === 'DEC') {
          return second - first;
        }
        return 0;
      }
      return this.defaultSort(a[column], b[column], type);
    });
    return sortedData;
  }

  sortNumber(a: any, b: any, type: string): number {
    if (type === 'INC') {
      return a - b;
    }
    if (type === 'DEC') {
      return b - a;
    }
    return 0;
  }

  defaultSort(a: any, b: any, type: string): number {
    if (type === 'INC') {
      if (a > b) return 1;
      return -1;
    } else if (type === 'DEC') {
      if (b > a) return 1;
      return -1;
    }
    return 0;
  }

  sortFormArray(
    a: AbstractControl,
    b: AbstractControl,
    column: string,
    type: string
  ) {
    const aControl = a.get(column)?.value;
    const bControl = b.get(column)?.value;

    if (!aControl && !bControl) return;
    if (typeof aControl === 'number' && typeof bControl === 'number')
      return this.sortNumber(aControl, bControl, type);

    return this.defaultSort(aControl, bControl, type);
  }
}
